/**
 * DQGMS mockup mode banner.
 *
 * Renders a bright amber strip at the top of every screen when the app
 * is running in mock mode. Dismissable per browser session (survives
 * navigation within the SPA, not across full-page reloads).
 *
 * Only renders when REACT_APP_USE_MOCK === 'true'. Otherwise returns null.
 * See DQGMS_MOCKUP_CHANGELOG.md for revert steps.
 */
import React, { useState } from 'react';

const DISMISS_KEY = 'dqgms_mockup_banner_dismissed';

function MockupBanner() {
  const mockOn = typeof process !== 'undefined' && process.env.REACT_APP_USE_MOCK === 'true';
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined') return false;
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  });

  if (!mockOn || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignore */ }
  };

  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        background: '#f4b942',
        color: '#3a2a05',
        padding: '6px 14px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #c99420',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}
    >
      <span>
        ⚠️ DEMO BUILD — data shown is illustrative, not from production
      </span>
      <button
        onClick={dismiss}
        aria-label="Dismiss mockup banner"
        style={{
          border: 'none',
          background: 'transparent',
          color: '#3a2a05',
          fontSize: 16,
          fontWeight: 700,
          cursor: 'pointer',
          padding: '0 6px',
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
}

export default MockupBanner;
